import { IconBase, IconComponent } from './BaseIcon';

export const Text: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M26.9 2H6.1c-2 0-3.6 1.6-3.6 3.6v4.5h2V5.6c.1-.9.8-1.6 1.6-1.6h9.3v24H10v2h12.9v-2h-5.5V4h9.4c.9 0 1.6.7 1.6 1.6v4.5h2V5.6c0-2-1.6-3.6-3.5-3.6z" />
  </IconBase>
);
